export const BILLS_LIST_HEIGHT = 280
